import videojs from 'video.js';

const Component = videojs.getComponent('Component');

export default class ErrorPopup extends Component {
  constructor(container) {
    super(container.player(), {});
    this._setDomListeners();
    container.el().append(this.el());
  }

  createEl() {
    const el = videojs.createEl('div', {
      className: 'vjs-chat-popup vjs-chat-error-popup',
    });
    el.insertAdjacentHTML('afterbegin', this.template);

    return el;
  }

  get template() {
    return `
      <div class="vjs-chat-popup__background"></div>
      <div class="vjs-chat-popup__container">
        <button class="vjs-chat-popup__close">
          <svg width="12" height="12" viewBox="0 0 612 670.2"><path fill="#424242" d="M345.2,335.1L603.4,44.7c9.9-9.9,9.9-27.3,0-37.2s-24.8-9.9-37.2,0L305.5,300.4L44.8,7.4C34.9-2.5,20-2.5,7.6,7.4c-9.9,9.9-9.9,27.3,0,37.2l258.2,290.5L7.6,625.6c-9.9,9.9-9.9,27.3,0,37.2s24.8,9.9,37.2,0l260.7-292.9l260.7,292.9c9.9,9.9,24.8,9.9,37.2,0c9.9-9.9,9.9-27.3,0-37.2L345.2,335.1z"></path></svg>
        </button>
        <span class="vjs-chat-error-message"></span>
      </div>
    `
  }

  _setDomListeners() {
    this.el()
      .querySelectorAll('.vjs-chat-popup__background, .vjs-chat-popup__close')
      .forEach((el) => {
        el.addEventListener('click', () => {
          this.el().classList.remove('vjs-chat-popup_show');
        });
      });
  }

  showError(errorMessage) {
    this.el().querySelector('.vjs-chat-error-message').innerText = errorMessage;
    this.el().classList.add('vjs-chat-popup_show');
  }
}